import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { AgmCoreModule } from '@agm/core';

import { environment } from 'src/environments/environment';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, environment.url + '/assets/i18n/', '.json');
}
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorI18nService } from './theme/utils/mat-paginator-i18n.service';

import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';
import { AppInterceptor } from './theme/utils/app-interceptor';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';


import { AppComponent } from './app.component';
import { AppSettings } from './app.settings';

// AngularFire Modules
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
// import { AngularFireFunctionsModule } from 'angularfire2/functions';

import { PagesComponent } from './pages/pages.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { Toolbar1Component } from './theme/components/toolbar1/toolbar1.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { ContactsComponent } from './theme/components/contacts/contacts.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import { LockScreenComponent } from './pages/lock-screen/lock-screen.component';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { CompaniesEffects } from './admin/1.tv/companies/companies.effects';
import { companyReducer } from './admin/1.tv/companies/store/reducers/companies.reducer';
import { siteReducer } from './admin/1.tv/sites/store/reducers/sites.reducer';
import { SitesEffects } from './admin/1.tv/sites/sites.effects';
import { productGroupReducer } from './admin/1.tv/product-groups/store/reducers/product-groups.reducer';
import { ProductGroupsEffects } from './admin/1.tv/product-groups/product-groups.effects';
import { productReducer } from './admin/1.tv/products/store/reducers/products.reducer';
import { ProductsEffects } from './admin/1.tv/products/products.effects';
import { userReducer } from './admin/1.tv/users/store/reducers/users.reducer';
import { UsersEffects } from './admin/1.tv/users/users.effects';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ApplicationsModule } from './admin/1.tv/applications/applications.module';
import { TvModule } from './pages/1.tv/tv.module';

@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    NotFoundComponent,
    UserMenuComponent,
    ContactsComponent,
    Toolbar1Component,
    HorizontalMenuComponent,
    FooterComponent,
    LockScreenComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    HttpClientModule,
    NgProgressModule,
    NgProgressHttpModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAygL6W8vFjImnrbn5clqMuLUHc8eBtYIo',
      libraries: ['places']
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    SharedModule,
    AngularFireModule.initializeApp(environment.firebase, 'admir-web-restaurant'), // imports firebase/app needed for everything,
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features,
    // AngularFirestoreModule.enablePersistence(),
    // Above line kills ipad logins, data etc.
    AngularFireStorageModule, // imports firebase/storage only needed for storage features
    StoreModule.forRoot({}),
    StoreDevtoolsModule.instrument({
      maxAge: 80, //  Retains last 80 states
      logOnly: environment.production // Restrict extension to log-only mode
    }),
    EffectsModule.forRoot([]),
    StoreModule.forFeature('companyReducer', companyReducer),
    EffectsModule.forFeature([CompaniesEffects]),
    StoreModule.forFeature('siteReducer', siteReducer),
    EffectsModule.forFeature([SitesEffects]),
    StoreModule.forFeature('productGroupReducer', productGroupReducer),
    EffectsModule.forFeature([ProductGroupsEffects]),
    StoreModule.forFeature('productReducer', productReducer),
    EffectsModule.forFeature([ProductsEffects]),
    StoreModule.forFeature('userReducer', userReducer),
    EffectsModule.forFeature([UsersEffects]),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    ApplicationsModule,
    TvModule
  ],
  providers: [
    AppSettings,
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    DatePipe,
    { provide: MatPaginatorIntl, useClass: MatPaginatorI18nService }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
